<div class="content-wrapper container-xxl p-0">
	<div class="content-body">

		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<!-- Modal plano -->
		<ng-template #modalBasic let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione o plano</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="planos" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Plano</h3>
							<input type="search" placeholder="Plano" class="ml-25 form-control"
								(keyup)="textFilter($event, 'plano')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.plano}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Pacote</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'pacote')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.pacote}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor Mensal</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'valor_mensal')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">R$ {{row.valor_mensal || currencyMask}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Operadora</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome_operadora')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome_operadora}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Broker</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome_broker')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome_broker}}</span>
						</ng-template>ç
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="selectPlano(row)" rippleEffect>
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal plano-->

		<!-- Modal Valores -->
		<ng-template #modalBasicValores let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Valores da Tabela</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<button type="button" (click)="modal.dismiss('Cross click')"
					class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1" rippleEffect>
					<i data-feather="arrow-left" class="ml-25"></i>
					Voltar para Tabelas
				</button>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="itensModal" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Quantidade de inicio</h3>
							<input type="search" placeholder="Quantidade de inicio" class="ml-25 form-control"
								(keyup)="textFilter($event, 'qtd_inicio')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.qtd_inicio}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Quantidade de Fim</h3>
							<input type="search" placeholder="Quantidade de final" class="ml-25 form-control"
								(keyup)="textFilter($event, 'qtd_fim')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.qtd_fim}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor p/ Ativo</h3>
							<input type="search" placeholder="Valor p/ Ativo" class="ml-25 form-control"
								(keyup)="textFilter($event, 'valor_ativo')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">R$ {{row.valor_ativo}}</span>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal Valores-->

		<!-- Modal tabelas -->
		<ng-template #modalBasicTabelas let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione a Tabela de Preço</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>

			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="itensTabelaPreco" [scrollbarH]="true">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Nome da Tabela</h3>
							<input type="search" placeholder="Nome da Tabela" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome}}</span><br>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-secondary btn-sm btn-add-new mr-1"
										(click)="visualizarValoresTabela(modalBasicValores,row.itens)" rippleEffect>
										Visualizar Valores
									</button>
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="definirTabela(row)" rippleEffect>
										Selecionar
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>



		</ng-template>
		<!-- / Modal tabelas-->

		<!-- Modal desconto-->
		<ng-template #modalBasicDesconto let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione o Desconto</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="descontos" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Desconto</h3>
							<input type="search" placeholder="Desconto" class="ml-25 form-control"
								(keyup)="textFilter($event, 'plano')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.desconto}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor/Percentual</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="valorFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold" *ngIf="row.valor">R$ {{row.valor}}</span>
							<span class="font-weight-bold" *ngIf="row.percentual">{{row.percentual}}%</span>
							<span class="font-weight-bold" *ngIf="!row.percentual && !row.valor">-</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Tempo</h3>
							<input type="search" placeholder="Tempo" class="ml-25 form-control"
								(keyup)="textFilter($event, 'tempo')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold" *ngIf="row.percentual || row.valor">{{row.tempo}} Dias</span>
							<span class="font-weight-bold" *ngIf="!row.percentual && !row.valor">-</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="selectDesconto(row)" rippleEffect>
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal desconto-->

		<section class="invoice-add-wrapper">
			<div *ngIf="starting" class="card invoice-preview-card">
				<div class="card-body invoice-padding pb-2 pt-2">
					<div class="progress-wrapper">
						<ngb-progressbar [striped]="true" [animated]="true" [value]="100"></ngb-progressbar>
					</div>
				</div>
			</div>
			<div *ngIf="!starting" class="row invoice-add">
				<div class="col-xl-9 col-md-8 col-12">
					<div class="card invoice-preview-card">
						<div class="card-body invoice-padding pb-0">
							<div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
								<div>
									<div class="logo-wrapper">
										<img style="border-radius: 15%;" src="assets/images/ico/favicon.ico" alt="">
										<h3 class="text-primary invoice-logo">Grupo 2E</h3>
									</div>
									<p class="card-text mb-25">Av. Pastor Martin Luther King Jr, 126 - Office 3000 sl
										1101 </p>
									<p class="card-text mb-25">Rio de Janeiro, RJ 20760-005, BR</p>
									<p class="card-text mb-0">(21) 2042-2324</p>
								</div>
								<div class="invoice-number-date mt-md-0 mt-2">
									<div *ngIf="pedido.id_pedido != null"
										class="d-flex align-items-center justify-content-md-end mb-1">
										<h4 class="invoice-title">Número do pedido</h4>
										<div class="input-group input-group-merge invoice-edit-input-group disabled">
											<div class="input-group-prepend">
												<div class="input-group-text">
													<i data-feather="hash"></i>
												</div>
											</div>
											<input type="text" class="form-control invoice-edit-input"
												value="{{pedido.num_pedido}}" placeholder="{{pedido.num_pedido}}"
												disabled />
										</div>
									</div>
								</div>
							</div>
						</div>

						<hr class="invoice-spacing" />

						<div class="card-body invoice-padding pt-0">
							<div class="row row-bill-to invoice-spacing">
								<div class="col-xl-6 mb-lg-1 col-bill-to pl-0">
									<h4 class="invoice-to-title">Informe o Cliente:</h4>
									<div class="invoice-customer">
										<input [disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
											type="text" class="form-control col-10 float-left"
											placeholder="CPF, CNPJ ou Nome do cliente" (keyup)="onKeyUp($event)"
											[(ngModel)]="termoPesquisa" matInput [matAutocomplete]="auto" />
										<span *ngIf="carregando"
											class="float-left spinner-border spinner-border-sm loading-suffix"></span>
										<mat-autocomplete #auto="matAutocomplete">
											<mat-option *ngFor="let option of clientes" [value]="option.nome"
												(click)="setCliente(option)">
												{{option.nome}}
											</mat-option>
										</mat-autocomplete>
										<br>
										<br>
										<span *ngIf="clienteNaoEncontrado" style="color: red;">Nenhum cliente
											encontrado.</span>

									</div>
								</div>
								<div class="col-xl-6 pl-0 pl-xl-1 pl-md-0 mt-xl-0 mt-2">
									<h4 class="mb-2">Detalhes do cliente:</h4>
									<span *ngIf="selectedCliente == null"><strong>Selecione um cliente</strong></span>
									<table *ngIf="selectedCliente != null">
										<tbody>
											<tr>
												<td class="pr-1" style="vertical-align: top;">Contratante:</td>
												<td>{{selectedCliente.nome_contratante}}</td>
											</tr>
											<tr>
												<td class="pr-1" style="vertical-align: top;">Email:</td>
												<td style="text-transform: lowercase;">{{selectedCliente.email_cliente == null ? '-' :
													selectedCliente.email_cliente}}</td>
											</tr>
											<tr>
												<td class="pr-1" style="vertical-align: top;">N. fantasia:</td>
												<td>{{selectedCliente.nome_fantasia}}</td>
											</tr>
											<tr>
												<td class="pr-1" style="vertical-align: top;">Razao social:</td>
												<td>{{selectedCliente.razao_social}}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<hr class="invoice-spacing" />
						<div class="card-body invoice-padding invoice-product-details" style="background-color: #fff;">
							<h3 style="font-size: 20px; font-weight: bold; margin-top: -35px;">
								<i data-feather="codepen" class="mr-25"></i>
								Produtos
							</h3>
							<br><br>
							<form class="source-item">
								<div data-repeater-list="group-a">
									<div class="repeater-wrapper" data-repeater-item
										*ngFor="let item of itensPedidoProduto; let i = index" @heightIn>
										<div class="row">
											<div class="col-12 d-flex product-details-border position-relative pr-0">
												<div class="row w-100 pr-lg-0 pr-1 py-2">
													<div class="col-lg-5 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
														<p class="card-text col-title mb-md-50 mb-0">Item

														</p>
														<div *ngIf="pedido.id_pedido == null">
															<select
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																class="form-control item-details" name="tipo-item"
																(change)="selectItem($event, i)">
																<option>{{itensPedidoProduto[i].itemTipo != null ?
																	"Alterar Item":
																	"Selecione um item"}}
																</option>
																<option *ngFor="let item_tipo of tipoItemproduto"
																	[value]="item_tipo.id_produto">
																	{{item_tipo.nome}}
																</option>
															</select>
															<!-- <div *ngIf="pedido.id_pedido != null">{{item.nomeTipoItem.nome}}
															</div> -->
															<br>
															<button [hidden]="item.itemTipo != 2" type="button"
																(click)="modalPlanoOpen(modalBasic, i)"
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1"
																rippleEffect>
																Selecionar Plano
															</button>
														</div>
														<div *ngIf="pedido.id_status == 2 || pedido.id_pedido != null">
															Item Selecionado:
															<span
																*ngIf="itensPedidoProduto[i].itemTipo == 3">TELEFONE</span>
															<!-- <span
																*ngIf="itensPedidoProduto[i].itemTipo == 2">CHIP</span> -->
														</div>
													</div>

													<div class="col-lg-2 col-12 my-lg-0 my-2">
														<p class="card-text col-title mb-md-2 mb-0">Valor Unidade</p>
														<input
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															prefix="R$ " type="text" (keyup)="alterarTotal()"
															mask="separator.2" [(ngModel)]="item.itemValor"
															id="itemValor{{ i }}" name="itemValor{{ i }}"
															class="form-control" placeholder="R$ 100" />
														<div [hidden]="item.itemTipo != 2">
															<div class="mt-1" [hidden]="item.itemPlanoId != null">
																<span style="color: rgb(239, 103, 103);"><b>Selecione um
																		plano</b></span>
															</div>
															<div style="white-space: nowrap" class="mt-1"
																[hidden]="item.itemPlanoId == null">
																<span><strong>Plano selecionado:</strong> </span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<span>Nome: </span>
																<span class="discount">{{item.itemPlanoNome}}</span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<span>Operadora: </span>
																<span
																	class="discount">{{item.itemPlanoOperadora}}</span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<span>Broker: </span>
																<span class="discount">{{item.itemPlanoBroker}}</span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
															</div>
														</div>
													</div>
													<div class="col-lg-2 col-12 my-lg-0 my-2">
														<p class="card-text col-title mb-md-2 mb-0">Qtd</p>
														<input
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															type="number" class="form-control" (keyup)="alterarTotal()"
															(change)="alterarTotal()" id="itemQuantity{{ i }}"
															name="itemQuantity{{ i }}" min='0'
															[(ngModel)]="item.quantidade" placeholder="0" />
														<div class="mt-1"
															[hidden]="item.quantidade != null && item.quantidade != 0 || item.itemTipo == null">
															<span style="color: #ef6767;"><b>* Obrigatório</b></span>
														</div>


													</div>
													<div class="col-lg-3 col-12 mt-lg-0 mt-2">
														<p class="card-text col-title mb-md-50 mb-0">Valor Item</p>
														<p class="card-text mb-0">R$ {{(item.itemValor *
															item.quantidade).toFixed(2)}}</p>

													</div>
												</div>
												<div
													class="d-flex flex-column align-items-center justify-content-between border-left invoice-product-actions py-50 px-25">
													<button (click)="deleteItem(i)" class="btn p-0"
														[disabled]="pedido.id_status == 2 || pedido.id_pedido != null">
														<i data-feather="x" [size]="18" class="cursor-pointer"></i>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="itensPedidoProduto.length == 0">Não há produtos adicionados no pedido
									</div>
								</div>
								<div class="row mt-1">
									<div class="col-12 px-0">
										<button [disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
											type="button" class="btn btn-primary btn-sm btn-add-new ml-1"
											(click)="addItem()" rippleEffect>
											<i data-feather="plus" class="mr-25"></i>
											<span class="align-middle">Adicionar Produto</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<hr class="invoice-spacing" />

						<div class="card-body invoice-padding invoice-product-details" style="background-color: #fff;">
							<h3 style="font-size: 20px; font-weight: bold; margin-top: -35px;">
								<i data-feather="tool" class="mr-25"></i>
								Serviços
							</h3>
							<br><br>
							<form class="source-item">
								<div data-repeater-list="group-a">
									<div class="repeater-wrapper" data-repeater-item
										*ngFor="let item of itensPedidoServico; let i = index" @heightIn>
										<div class="row">
											<div class="col-12 d-flex product-details-border position-relative pr-0">
												<div class="row w-100 pr-lg-0 pr-1 py-2">
													<div class="col-lg-3 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
														<p class="card-text col-title mb-md-50 mb-0">Item
														</p>
														<div *ngIf="pedido.id_pedido == null">
															<select
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																class="form-control item-details" name="tipo-item"
																(change)="selecionarServico($event, i)">
																<option>{{itensPedidoServico[i].servicoSelecionado !=
																	null ?
																	"Alterar Item":
																	"Selecione um item"}}
																</option>
																<option *ngFor="let item_tipo of tipoItemServico"
																	[value]="item_tipo.id_servico">
																	{{item_tipo.nome}}
																</option>
															</select>
															<br>
															<button
																[hidden]="itensPedidoServico[i].servicoSelecionado != '11'"
																type="button" (click)="modalPlanoOpen(modalBasic, i)"
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1"
																rippleEffect>
																Selecionar Plano
															</button>
														</div>
														<div *ngIf="pedido.id_pedido != null">
															{{item.nomeTipoItem.nome}}
														</div>
														<div
															[hidden]="itensPedidoServico[i].servicoSelecionado != '11'">
															<div class="mt-1" [hidden]="item.itemPlanoId != null">
																<span style="color: rgb(239, 103, 103);"><b>Selecione um
																		plano</b></span>
															</div>
															<div style="white-space: nowrap" class="mt-1"
																[hidden]="item.itemPlanoId == null">
																<span><strong>Plano selecionado:</strong> </span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<span>Nome: </span>
																<span class="discount">{{item.itemPlanoNome}}</span>
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<!-- <span>Assinatura para ativação: </span>
																<span
																	class="discount">{{item.itemPlanoValorAtivacao}}</span> -->
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
																<!-- <span>Consumo mínimo do 0800 ativo: </span>
																<span class="discount">{{item.itemPlanoValorMin}}</span> -->
															</div>
															<div style="white-space: nowrap" class="mt-0"
																[hidden]="item.itemPlanoId == null">
															</div>
														</div>

														<!-- <select *ngIf="pedido.id_pedido == null"
															class="form-control item-details" name="tipo-item"
															(change)="selecionarServico($event, i)">
															<option>{{item.itemTipo != null ? "Alterar Item":
																"Selecione um item"}}
															</option>
															<option *ngFor="let item_tipo of tipoItemServico"
																[ngValue]="(item_tipo.id_servico)">
																{{item_tipo.nome}}
															</option>
														</select>
														<div *ngIf="pedido.id_pedido != null">{{item.nomeTipoItem.nome}}
														</div> -->
													</div>
													<div class="col-lg-3 col-12 my-lg-0 my-2">
														<p class="card-text col-title mb-md-2 mb-0">Condição</p>
														<select
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null || itensPedidoServico[i].servicoSelecionado == '11'"
															[(ngModel)]="item.condicaoSelected"
															class="form-control item-details" name="tipo-item"
															(change)="selectItemTabelaPreco($event, i)">
															<option [value]="'1'">Valor Fixo
															</option>
															<option [value]="'2'">Tabela de Preço
															</option>
														</select>
													</div>
													<div class="col-lg-3 col-12 mt-lg-0 mt-2"
														*ngIf="itensPedidoServico[i].condicaoSelected == 1">
														<p class="card-text col-title mb-md-50 mb-0">Valor P/ Ativo</p>
														<input
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															prefix="R$ " type="text" mask="separator.2"
															[(ngModel)]="item.itemValorFixo" id="itemValor{{ i }}"
															name="itemValor{{ i }}" class="form-control mr-1"
															placeholder="R$ 0" />
													</div>
													<div class="col-lg-3 col-12 my-lg-0 my-2"
														*ngIf="itensPedidoServico[i].condicaoSelected == 2">
														<p class="card-text col-title mb-md-2 mb-0">Tabela</p>
														<button *ngIf="itensPedidoServico[i].condicaoSelected == 2"
															type="button" style="width: 100% !important;"
															(click)="modalPlanoOpen(modalBasicTabelas, i)"
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1"
															rippleEffect>
															Selecionar
														</button>
														<br>
														<span><b>Tabela Selecionada:</b></span>
														<span
															*ngIf="itensPedidoServico[i].tabelaSelecionada == null">Nenhuma
															foi selecionada.</span>
														<span
															*ngIf="itensPedidoServico[i].tabelaSelecionada != null">{{itensPedidoServico[i].tabelaSelecionada.nome}}</span>
													</div>
													<div class="col-lg-3 col-12 mt-lg-0 my-2">
														<p class="card-text col-title mb-md-50 mb-0">Valor Mínimo</p>
														<input
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															prefix="R$ " type="text" mask="separator.2"
															[(ngModel)]="item.itemValorMinimo" name="txtVlMinimo{{ i }}"
															class="form-control mr-1" placeholder="R$ 0" />
													</div>
												</div>
												<div
													class="d-flex flex-column align-items-center justify-content-between border-left invoice-product-actions py-50 px-25">
													<button (click)="deleteItemProdutoServico(i)" class="btn p-0"
														[disabled]="pedido.id_status == 2 || pedido.id_pedido != null">
														<i data-feather="x" [size]="18" class="cursor-pointer"></i>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="itensPedidoServico.length == 0">Não há serviços adicionados no pedido
									</div>
								</div>
								<div class="row mt-1">
									<div class="col-12 px-0">
										<button [disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
											type="button" class="btn btn-primary btn-sm btn-add-new ml-1"
											(click)="addItemProdutoServico()" rippleEffect>
											<i data-feather="plus" class="mr-25"></i>
											<span class="align-middle">Adicionar Serviço</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<hr class="invoice-spacing" />

						<div class="card-body invoice-padding">
							<div class="row invoice-sales-total-wrapper">
								<div class="col-md-6 order-md-1 order-2 mt-md-0 mt-3">
									<div class="d-flex align-items-center mb-1">
									</div>
								</div>
								<div class="col-md-6 d-flex justify-content-end order-md-2 order-1">
									<div class="invoice-total-wrapper">

										<!-- <hr class="my-50" />
										<div class="invoice-total-item">
											<h3 class="invoice-total-title">Subtotal:</h3>
											<h3 class="invoice-total-amount">R$ {{valorTotal.toFixed(2)}}</h3>
										</div>
										<hr class="my-50" />
										<div class="invoice-total-item">
											<h2 class="invoice-total-title">Total:</h2>
											<h2 class="invoice-total-amount">R$ {{valorTotal.toFixed(2)}}</h2>
										</div> -->
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">

					<div *ngIf="pedido.id_pedido != null" class="card">
						<div class="card-body">
							<span *ngIf="pedido.id_status == 2">* Contrato Gerado.<br><br></span>
							<div class="form-group mb-2">
								<label for="basicSelect">Dia do vencimento:</label>
								<div class="input-group" *ngIf="contrato.num_contrato == null">
									<select [disabled]="pedido.id_status == 2" class="form-control" name="dt_contrato"
										[(ngModel)]="contrato.dt_vencimento" required>
										<option value="05">Dia 05</option>
										<option value="10">Dia 10</option>
										<option value="15">Dia 15</option>
										<option value="25">Dia 25</option>
									</select>
								</div>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.dt_vencimento}}</span>
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="basicSelect">Data do Contrato:</label>
								<div class="input-group" *ngIf="contrato.num_contrato == null">
									<input class="form-control" placeholder="Selecione a data" required
										[disabled]="pedido.id_status == 2" name="dt_contrato"
										[(ngModel)]="contrato.dt_contrato" ngbDatepicker #dp="ngbDatepicker" />
									<button class="btn btn-outline-secondary bi feather icon-calendar"
										[disabled]="pedido.id_status == 2" (click)="dp.toggle()" type="button"></button>
								</div>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.dt_contrato | date}}</span>
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="basicSelect">Data de Fidelidade do Contrato:</label>
								<div class="input-group" *ngIf="contrato.num_contrato == null">
									<input class="form-control" placeholder="Selecione a data" required
										[disabled]="pedido.id_status == 2" name="dt_fidelidade"
										[(ngModel)]="contrato.dt_fidelidade" ngbDatepicker #dp="ngbDatepicker" />
									<button class="btn btn-outline-secondary bi feather icon-calendar"
										[disabled]="pedido.id_status == 2" (click)="dp.toggle()" type="button"></button>
								</div>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.dt_fidelidade | date}}</span>
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="basicSelect">Tempo Inadimplência/Bloqueio *</label>
								<select [disabled]="pedido.id_status == 2" [(ngModel)]="contrato.tempo_bloqueio"
									*ngIf="contrato.num_contrato == null" name="tempo_bloqueio" class="form-control"
									id="basicSelect" required>
									<!-- <option value="5">5 dias</option> -->
									<option value="15">15 dias</option>
									<option value="30">30 dias</option>
								</select>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.tempo_bloqueio }} dias</span>
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="basicSelect">Gerar NF:</label>
								<select [disabled]="pedido.id_status == 2" [(ngModel)]="contrato.gerar_nf"
									*ngIf="contrato.num_contrato == null" class="form-control" name="gerarnf">
									<option [value]="true">Sim</option>
									<option [value]="false">Não</option>
								</select>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.gerar_nf ? 'SIM' : 'NÃO'}}</span>
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="basicSelect">Gerar Fatura:</label>
								<select [disabled]="pedido.id_status == 2" [(ngModel)]="contrato.gerar_fatura"
									*ngIf="contrato.num_contrato == null" class="form-control" name="gerarnf">
									<option [value]="true">Sim</option>
									<option [value]="false">Não</option>
								</select>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.gerar_fatura ? 'SIM' : 'NÃO'}}</span>
								</div>
							</div>
							<div class="form-group mb-2" style="display: none;">
								<label for="basicSelect">Carência:</label>
								<select [disabled]="pedido.id_status == 2" [(ngModel)]="contrato.carencia"
									*ngIf="contrato.num_contrato == null" class="form-control" name="gerarnf">
									<option [value]="true">Sim</option>
									<option [value]="false">Não</option>
								</select>
							</div>
							<div class="form-group mb-2" [hidden]="contrato.carencia == false">
								<label for="basicSelect">Carência Até:</label>
								<div class="input-group" *ngIf="contrato.num_contrato == null">
									<input [disabled]="pedido.id_status == 2" class="form-control"
										placeholder="Selecione a data" required name="dt_carencia"
										[(ngModel)]="contrato.dt_carencia" ngbDatepicker #dp2="ngbDatepicker" />
									<button [disabled]="pedido.id_status == 2"
										class="btn btn-outline-secondary bi feather icon-calendar"
										(click)="dp2.toggle()" type="button"></button>
								</div>
								<div *ngIf="contrato.num_contrato">
									<span>{{contrato.dt_carencia | date}}</span>
								</div>
							</div>

							<div *ngIf="contrato.num_contrato">
								<label>Número do contrato:</label><br>
								<span>{{contrato.num_contrato}}</span><br><br>
							</div>

							<div *ngIf="contrato.num_contrato">
								<label>Data Criação do Contrato:</label><br>
								<span>{{contrato.dt_insert | date}}</span><br><br>
							</div>

							<div class="invoice-total-item" [hidden]="desconto_selecionado.length == 0">
								<label>Isenção Aplicada:</label>
							</div>
							<div>
								<div class="invoice-total-item" *ngFor="let item of desconto_selecionado">

									<span class="invoice-total-title" (click)="removerDesconto(item.descontoId)"><i
											data-feather="x" [size]="18" class="cursor-pointer"></i> {{item.desconto}}
									</span>
									<!-- <h3 class="invoice-total-amount"> {{item.descontoValor == null ?
										item.descontoPercentual + '%' : 'R$' + item.descontoValor}}</h3> -->
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<button routerLink="/pedido-faleflex/"
								class="btn btn-outline-primary btn-block mb-75 imprimir" rippleEffect>
								Voltar
							</button>
							<button *ngIf="pedido.id_status == 2 && podeCancelar" class="btn btn-outline-danger btn-block mb-75"
								(click)="cancelarPedido()" [disabled]="loadingCancelamento" rippleEffect>
								<span *ngIf="loadingCancelamento" class="spinner-border spinner-border-sm mr-1"></span>
								<span>Cancelar Pedido</span>
							</button>
							<button *ngIf="pedido.id_pedido == null" class="btn btn-primary btn-block mb-75"
								(click)="efetuarPedido(false)" [disabled]="loading || contrato.id_contrato != null"
								rippleEffect>
								<span *ngIf="loading && !loadingContrato"
									class="spinner-border spinner-border-sm mr-1"></span>
								<span>Efetuar Pedido</span>
								<span *ngIf="pedido.id_pedido != null">Atualizar Pedido</span>
							</button>
							<button class="btn btn-primary btn-block mb-75"
								(click)="modalDescontoOpen(modalBasicDesconto, i)" [disabled]="pedido.id_status == 2"
								*ngIf="pedido.id_pedido != null" rippleEffect>
								<span *ngIf="loading && !loadingContrato"
									class="spinner-border spinner-border-sm mr-1"></span>
								<span>Aplicar Isenção</span>
							</button>
							<button [disabled]="pedido.id_status == 2" *ngIf="pedido.id_pedido != null"
								class="btn btn-primary btn-block mb-75" (click)="gerarContrato(true)"
								[disabled]="loading" rippleEffect>
								<span *ngIf="loadingContrato" class="spinner-border spinner-border-sm mr-1"></span>
								<span>Gerar Contrato</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>